const STRUCTURED_FIELDS = [
  "name", "code", "stage", "lensId", "recoverable", "originalPreserved", "details",
];

/** Preserve known structured error fields when sending through JSON or IPC. */
export function serializeError(error) {
  const output = {
    message: error?.message || String(error || "Unknown error"),
    stack: error?.stack || null,
  };
  for (const field of STRUCTURED_FIELDS) {
    if (error?.[field] !== undefined) output[field] = error[field];
  }
  return output;
}

/** Rehydrate an Error while retaining the discriminants used by UI code. */
export function deserializeError(value, fallback = "Operation failed.") {
  if (value instanceof Error) return value;
  const candidate = value && typeof value === "object" ? value : { message: value };
  const error = new Error(candidate.message || fallback);
  for (const field of STRUCTURED_FIELDS) {
    if (candidate[field] !== undefined) error[field] = candidate[field];
  }
  if (candidate.stack) error.stack = candidate.stack;
  return error;
}
